var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUkFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 31"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#uk-flag_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M0 .31h40v30H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m4.688.31 15.25 11.313L35.125.311H40v3.875L25 15.373l15 11.125v3.813h-5L20 19.123 5.063 30.311H0v-3.75l14.938-11.125L0 4.31v-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M26.5 17.873 40 27.811v2.5L23.063 17.873zM15 19.123l.375 2.188-12 9H0zM40 .311v.187l-15.562 11.75.125-2.75L36.875.311zm-40 0 14.938 11h-3.75L0 2.935z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.063.31v30h10v-30zM0 10.31v10h40v-10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M0 12.373v6h40v-6zM17.063.311v30h6v-30z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "uk-flag_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 30,
  y: 0.311,
  fill: "#fff",
  rx: 6
})))));
export { SvgUkFlag as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZjM1ZmI4YTg2ZWRmZWZkMTZhMDIyZWIzZDBlODIzNTEuc3ZnIjs=";